import React, { useEffect } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

const ClosedCaption = (props) => {

    const { transcript, resetTranscript } = useSpeechRecognition();

    useEffect(() => {
        if (props.isEnabled) {
            SpeechRecognition.startListening({ continuous: true, });
        }
        else {
            resetTranscript();
            SpeechRecognition.stopListening();
        }
    }, [props.isEnabled]);

    let transcriptComponent = <p className="video-chat__caption">
        {transcript}
    </p>

    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
        transcriptComponent = <div className="video-chat__caption">
            Browser not supported!
        </div>
    }

    return props.isEnabled && transcriptComponent;
}

export default ClosedCaption;